import React from "react";
import { Row, Col } from "react-bootstrap";
import SectionLayout from "../common/SectionLayout";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/unnamed.png";
import { SECTION_TITLES } from "../../config/constants";
import SocialLinks from "../common/SocialLinks";
import FeaturedArticlesCarousel from "../Articles/FeaturedArticlesCarousel";

function AboutDivider() {
  return <div className="about-section-divider" aria-hidden="true" />;
}

function AboutBlockHeading({ title, accent }) {
  return (
    <h2 className="about-block-heading">
      {title} <strong className="purple">{accent}</strong>
    </h2>
  );
}

function About() {
  const introParts = SECTION_TITLES.about.intro.split(" ");
  const introLead = introParts.slice(0, -1).join(" ");
  const introAccent = introParts[introParts.length - 1];

  const skillsetParts = SECTION_TITLES.about.skillset.split(" ");
  const skillsetLead = skillsetParts.slice(0, 1).join(" ");
  const skillsetAccent = skillsetParts.slice(1).join(" ");

  return (
    <SectionLayout className="about-section" id="about">
      <section className="about-block about-block-intro">
        <Row className="about-intro-row">
          <Col md={7} className="about-intro-content">
            <AboutBlockHeading title={introLead} accent={introAccent} />
            <Aboutcard />
          </Col>
          <Col md={5} className="about-img">
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>
        </Row>
      </section>

      <AboutDivider />

      <section className="about-block about-block-articles">
        <FeaturedArticlesCarousel />
      </section>

      <AboutDivider />

      <section className="about-block about-block-skills">
        <AboutBlockHeading title={skillsetLead} accent={skillsetAccent} />
        <Techstack />
      </section>

      <AboutDivider />

      <section className="about-block about-block-github">
        <Github />
      </section>

      <AboutDivider />

      <section className="about-block about-block-social">
        <AboutBlockHeading title="FIND ME" accent="ON" />
        <p className="about-social-text">
          Feel free to <span className="purple">connect </span>with me
        </p>
        <SocialLinks variant="home" />
      </section>
    </SectionLayout>
  );
}

export default About;
